export const iconFontAwesomeBuildingsTent = (
	<i className="fa-solid fa-tent"></i>
);
